import { StoreState } from 'state/ducks'
import { SearchResult } from './models'

export const getLocationUnits = (state: StoreState): SearchResult => state.locationUnit.data
